import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import qs from 'qs';

import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import { MuiThemeProvider } from 'material-ui/styles';
import whyDidYouUpdate from 'why-did-you-update';
// third party css
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import {
    StylesProvider,
    createGenerateClassName,
    MuiThemeProvider as MuiCoreThemeProvider
} from '@material-ui/core/styles';

// 1st party css
import './scss/app.css';

import { unregister } from './registerServiceWorker';
import { getStore, getHistory, getPersister } from './state/store';

import SideNav from './view/nav/SideNav';
import Toast from './view/factory/Toast';
import RouteFactory from './view/factory/RouteFactory';

import CalendarDialogs from './view/calendar/calendar-dialogs/CalendarDialogs';
import ErrorDialog from './view/common/ErrorDialog';
import TrainHeroicTheme, { customTheme } from './view/TrainHeroicTheme';

import CONFIG from './api/config';
import EnvironmentBanner from './view/common/EnvironmentBanner';
import MaintenanceGate from './view/common/MaintenanceGate';

// Unused import required to initialize rollbar
import { rollbar } from '../src/lib/rollbarConfig';

// while this appears to be unused, it is importing a snippet to connect the
// Segment API, so please leave it in place
import '../src/lib/segment/SegmentLoader';
import SegmentService from '../src/lib/segment/SegmentService';
import loadAmbassadorWindowMbsyObject from '../src/lib/loadAmbassadorWindowMbsyObject';
import TermsOfUsePrompt from './v5/termsOfUse/components/TermsOfUsePrompt';
import FeatureFlag from './v5/features/components/FeatureFlag';
import { FEATURES } from './v5/features/components/constants';

SegmentService.setParamParser((path, route) => {
    // eslint-disable-next-line
    const [questionMark, ...queryString] = path.search;

    // Return a combination of parameters from the router and query string
    // parameters.
    return {
        ...route.params,
        ...qs.parse(queryString.join(''))
    };
});

if (CONFIG.WHY_DID_YOU_UPDATE_ON) {
    whyDidYouUpdate(React);
}

loadAmbassadorWindowMbsyObject();

const generateClassName = createGenerateClassName({
    productionPrefix: 'c',
    disableGlobal: true
});

ReactDOM.render(
    <Provider store={getStore()}>
        <PersistGate persistor={getPersister()}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <ErrorDialog />
                <MaintenanceGate>
                    <EnvironmentBanner>
                        <StylesProvider generateClassName={generateClassName}>
                            <MuiThemeProvider theme={TrainHeroicTheme}>
                                <MuiCoreThemeProvider theme={customTheme}>
                                    <SideNav />
                                    <ConnectedRouter
                                        history={getHistory()}
                                        store={getStore()}
                                    >
                                        {RouteFactory()}
                                    </ConnectedRouter>
                                    <Toast />
                                    <CalendarDialogs />
                                    <FeatureFlag
                                        feature={FEATURES.PARENTAL_CONSENT_V2}
                                    >
                                        <TermsOfUsePrompt />
                                    </FeatureFlag>
                                </MuiCoreThemeProvider>
                            </MuiThemeProvider>
                        </StylesProvider>
                    </EnvironmentBanner>
                </MaintenanceGate>
            </MuiPickersUtilsProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js